__webpack_require__.p = "https://beta.na.safer.whs.amazon.dev/";